import React from 'react';
import style from './AppStoreLink-style.scss';

const AppStoreLinkReactLazy = React.lazy(() =>
    import(/* webpackChunkName: "AppStoreLink" */ './AppStoreLink')
);

const AppStoreLinkPlaceholder = () => <div className={style.placeholder} />;

const AppStoreLinkLazy = () => {
    return (
        <React.Suspense fallback={<AppStoreLinkPlaceholder />}>
            <AppStoreLinkReactLazy />
        </React.Suspense>
    );
};

export default AppStoreLinkLazy;
